import React, { useEffect, useState, useRef } from 'react';
interface DecryptedTextProps {
  text: string;
  className?: string;
  speed?: number;
  maxIterations?: number;
  characters?: string;
  animateOn?: 'view' | 'hover' | 'mount';
}
const DEFAULT_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ!@#$%^&*()_+-=[]{}|;:,.<>?';
export function DecryptedText({
  text,
  className = '',
  speed = 50,
  maxIterations = 10,
  characters = DEFAULT_CHARS,
  animateOn = 'view'
}: DecryptedTextProps) {
  const [display, setDisplay] = useState(text);
  const [isDecrypting, setIsDecrypting] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);
  const hasAnimated = useRef(false);
  const decrypt = () => {
    if (isDecrypting) return;
    setIsDecrypting(true);
    let iteration = 0;
    const len = text.length;
    const interval = setInterval(() => {
      setDisplay(() => text.split('').map((char, i) => {
        // Preserve spaces and existing letters once iteration passes them
        if (char === ' ') return ' ';
        if (i < iteration) return text[i];
        return characters[Math.floor(Math.random() * characters.length)];
      }).join(''));
      iteration += 1 / 2;
      if (iteration >= len) {
        clearInterval(interval);
        setDisplay(text);
        setIsDecrypting(false);
      }
    }, speed);
  };
  useEffect(() => {
    if (animateOn === 'mount') {
      decrypt();
      return;
    }
    if (animateOn === 'view') {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          decrypt();
        }
      }, {
        threshold: 0.3
      });
      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }
  }, [text]);
  return <span ref={ref} className={`inline-block font-mono ${className}`} onMouseEnter={animateOn === 'hover' ? decrypt : undefined} style={{
    minWidth: `${text.length}ch`
  }} data-id="element-225">
      {display}
    </span>;
}